import React from 'react';

/**
 * ProjectedVolumeField Component
 * Renders a text input for annual projected volume with validation feedback.
 * Props:
 *  - state: form state object
 *  - handleChange: input change handler
 */
const ProjectedVolumeField = ({ state, handleChange }) => {
  return (
    <div className="col-lg-2">
      <div className="form-floating mb-4 position-relative">
        <input
          type="text"
          className={`form-control ${
            state.errors.projectedVolume ? 'is-invalid' : state.projectedVolume ? 'is-valid' : ''
          }`}
          id="projectedVolume"
          name="projectedVolume"
          value={state.projectedVolume}
          onChange={handleChange}
          placeholder=" "
          autoComplete='off'
        />
        <label htmlFor="projectedVolume">Annual Volume</label>
        {/* Show error tooltip if validation fails */}
        {state.errors.projectedVolume && (
          <div className="invalid-tooltip">{state.errors.projectedVolume}</div>
        )}
        {/* Show success tooltip if field is valid */}
        {state.projectedVolume && !state.errors.projectedVolume && (
          <div className="valid-tooltip">Annual Volume is valid</div>
        )}
      </div>
    </div>
  );
};

export default ProjectedVolumeField; 